import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system';
export const AddAccountHeader = ({ icon }) => (<View style={styles.container}>
    <View style={styles.squircle}>{icon}</View>

    <View style={styles.textContainer}>
      <Text Secondary TextThin-20>
        What’s the current balance for this account?
      </Text>
    </View>
  </View>);
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        marginBottom: rem(24),
    },
    squircle: {
        marginBottom: rem(16),
    },
    textContainer: {
        alignItems: 'center',
    },
});
export default AddAccountHeader;
